export const KEYCLOCK_REALM_NAME = process.env.KEYCLOCK_REALM_NAME ? process.env.KEYCLOCK_REALM_NAME : 'mac-stage';
export const KEYCLOCK_CLIENT_ID = process.env.VUE_APP_KEYCLOCK_CLIENT_ID
  ? process.env.VUE_APP_KEYCLOCK_CLIENT_ID
  : 'iron-ant_engine';
export const LAUNCHER_CLIENT_ID = process.env.VUE_APP_LAUNCHER_CLIENT_ID
  ? process.env.VUE_APP_LAUNCHER_CLIENT_ID
  : 'https://multibook.mac.pl';
export const KEYCLOCK_SSO = process.env.VUE_APP_SSO ? process.env.VUE_APP_SSO : 'https://sso.mac.pl';
export const BASE_URL = process.env.VUE_APP_BASE_URL;
export const SERVICE_URL = process.env.VUE_APP_SERVICE_URL;
export const KEYCLOACK_URL_WITH_PORT = process.env.VUE_APP_KEYCLOACK_URL_WITH_PORT;
export const PORT_EXP = `8080`;

export const MULTIBOOK_EXTERNAL = process.env.VUE_APP_MULTIBOOK_EXTERNAL || process.env.MULTIBOOK_EXTERNAL;
const PORT = `8080`;
const KEYCLOCK_PORT = `8008`;
export const APP_URL = process.env.NODE_ENV === 'development' ? `${BASE_URL}:${PORT}` : `${BASE_URL}`;
export const LAUNCHER_URL =
  process.env.NODE_ENV === 'development' || (process.env.NODE_ENV === 'production' && process.env.VUE_APP_LOCAL_MACHINE)
    ? `${LAUNCHER_CLIENT_ID}:${PORT}`
    : `${LAUNCHER_CLIENT_ID}`;
// export const APP_URL = process.env.NODE_ENV_TEST === 'development' ? `${BASE_URL}:${PORT}` : `${BASE_URL}`;

import appConfigModule from './app.ports';
const appConfig = appConfigModule(
  BASE_URL,
  KEYCLOCK_REALM_NAME,
  KEYCLOCK_CLIENT_ID,
  KEYCLOCK_SSO,
  KEYCLOCK_PORT,
  KEYCLOACK_URL_WITH_PORT,
  APP_URL
);

export const KEYCLOCK_URL = appConfig.KEYCLOCK_URL;
export const REDIRECT_URL = appConfig.REDIRECT_URL;
export const setHeader = appConfig.setHeader;
